var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pcg-btn',{staticClass:"prk-button",attrs:{"round":"","text":"download_pdf","disabled":_vm.disabled,"icon":_vm.iconPdf},on:{"click":_vm.downloadPdf}})}
var staticRenderFns = []

export { render, staticRenderFns }